import '../button/button.scss';

export function Button(props) {
  return (
    <div className='reset-btn'>
    <button
      id={typeof props.id !== "undefined" ? props.id : null}
      className={typeof props.classes !== "undefined" && props.classes !== "" ?  props.classes : "btn-structure btn-default" }
      disabled={props.disabled}
      onClick={typeof props.onClickMethod !== "undefined" && props.onClickMethod  !== "" ? props.onClickMethod : null}
      title={props.desc}
      type={props.type || "button"}
    >
        {props.buttonTxt}
        {typeof props.google_icon  !== "undefined"  && 
        <span className="material-symbols-outlined">
          {props.google_icon}
          </span>}
    </button>
    </div>
  );
}
export default Button;
